import { useTranslation as useI18nTranslation } from "react-i18next";

/**
 * Custom hook wrapper for react-i18next useTranslation
 * Provides type-safe translation access with a simpler API
 *
 * @example
 * const t = useTranslation();
 * <h1>{t("home.title")}</h1>
 */
export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();

  const changeLanguage = (lang: "es" | "en") => {
    i18n.changeLanguage(lang);
  };

  return {
    t: (key: string, options?: Record<string, unknown>) => t(key, options),
    currentLanguage: i18n.language as "es" | "en",
    changeLanguage,
    isSpanish: i18n.language === "es",
    isEnglish: i18n.language === "en",
  };
};
